import { API } from "aws-amplify";

export default async function getOnboardRequestDetails(data) {
  return await API.get("paymentAcceptanceOnboard", `/get-onboard-request`);
}